import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardBody, CardHeader } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getObligationList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditObligationModal from './Add_Edit/AddEditObligationModal';
import DeleteObligationModal from './Delete/DeleteObligation';
import { getRolesList } from '../../../slices/thunks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const ObligationsList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();
	const [dataObligation, setDataObligation] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Obligation
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);


	const selectorObligations = createSelector(
		state => state.Obligations,
		obligation => ({
			obligationList: obligation.obligationList,
			isLoadingList: obligation.isLoadingList,
			isObligationSuccess: obligation.isObligationSuccess,
			error: obligation.error,
			isAdding: obligation.isAdding,
			isAdded: obligation.isAdded,
			isAddError: obligation.isAddError,
			isUpdating: obligation.isUpdating,
			isUpdated: obligation.isUpdated,
			isUpdateError: obligation.isUpdateError,
			isDeleting: obligation.isDeleting,
			isDeleted: obligation.isDeleted,
			isDeleteError: obligation.isDeleteError,
		})
	);

	const { obligationList, isLoadingList } = useSelector(selectorObligations);

	useEffect(() => {
		dispatch(getObligationList());
	}, []);

	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = obligation => {
		setDataObligation(obligation);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = obligation => {
		setDataObligation(obligation);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'obligation',
				columnDefType: 'display',
				 width: 5,
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												title={'Editar'}
												to='#'
												onClick={() => {
													const obligationData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(obligationData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Eliminar'}
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const obligationData =
														cellProps.row.original;
													handleClickDelete(obligationData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Código', accessorKey: 'code',  width: 10 },
			{
				header: 'Nombre', accessorKey: 'name',  width: '30%',
				Cell: ({ row }) => {
					return (
						<div className='no-nowrap'>
							{row.original.name}
						</div>
					);
				},
			},
			{
				header: 'Impacto',
				accessorKey: 'impact.name',
				
				width: 5,
				Cell: ({ row }) => {
					let status = row.original.impact;
			
					// Si status no existe, retorna una cadena vacía
					if (!status) {
						return '';
					}
			
					let bgColor = status.bgcolor;  
					let txColor = status.txcolor ;
			
					return (
						<div>
							<span className="badge" style={{ backgroundColor: bgColor, color: txColor }}>
								<i className={`align-middle ${status.icon}`}></i> {status.name}
							</span>
						</div>
					);
				},
			},
			
			{
				header: 'Probabilidad',
				accessorKey: 'probability.name',
				 width: 5,
				Cell: ({ row }) => {
					let status = row.original.probability
			
					// Si status no existe, retorna una cadena vacía
					if (!status) {
						return '';
					}
			
					let bgColor = status.bgcolor;  
					let txColor = status.txcolor ;
			
					return (
						<div>
							<span className="badge" style={{ backgroundColor: bgColor, color: txColor }}>
								<i className={`align-middle ${status.icon}`}></i> {status.name}
							</span>
						</div>
					);
				},
			},
			{
				header: 'Criticidad',
				accessorKey: 'criticality.name',
				 width: 5,
				Cell: ({ row }) => {
					let status = row.original.criticality
			
					// Si status no existe, retorna una cadena vacía
					if (!status) {
						return '';
					}
			
					let bgColor = status.bgcolor;  
					let txColor = status.txcolor ;
			
					return (
						<div>
							<span className="badge" style={{ backgroundColor: bgColor, color: txColor }}>
								<i className={`align-middle ${status.icon}`}></i> {status.name}
							</span>
						</div>
					);
				},
			},
			{ header: 'Aspecto Relevante', accessorKey: 'relevant_aspect.name',  },
			{ header: 'Componente Ambiental', accessorKey: 'environmental_component.name',  },
			{ header: 'Fase de Aplicación', accessorKey: 'application_phase.name',  },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataObligation({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Obligación
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={obligationList || []}
								isLoadingData={isLoadingList}
								nameFile={'obligaciones'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataObligation({});
											handleToggleModal();
										},
										title: 'Crear Obligación'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditObligationModal
				dataObligation={dataObligation}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteObligationModal
				dataObligation={dataObligation}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default ObligationsList;
